import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "icon"]
  static values = { open: Boolean }

  connect() {
    this.mediaQuery = window.matchMedia("(max-width: 768px)")
    this.handleMediaChange = this.onMediaChange.bind(this)
    this.mediaQuery.addEventListener("change", this.handleMediaChange)
    this.applyState()
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.handleMediaChange)
  }

  toggle() {
    if (!this.mediaQuery.matches) return
    this.openValue = !this.openValue
    this.applyState()
  }

  onMediaChange() {
    this.applyState()
  }

  applyState() {
    if (this.mediaQuery.matches) {
      this.panelTarget.classList.toggle("mobile-filter-closed", !this.openValue)
      this.updateIcon()
    } else {
      this.panelTarget.classList.remove("mobile-filter-closed")
      this.iconTarget.style.transform = ""
    }
  }

  updateIcon() {
    this.iconTarget.style.transform = this.openValue ? "rotate(0deg)" : "rotate(-90deg)"
  }
}
